declare global {
  interface Window {
    FS: any;
  }
}

export const getFullStorySessionId = () => {
  if (window.FS) {
    return window.FS.getCurrentSession();
  }
};

export const fullStoryLog = (payload: any) => {
  if (typeof window.FS?.log === "function") {
    let message;

    try {
      message = JSON.stringify(payload);
    } finally {
    }

    if (message) {
      window.FS?.log(message);
    }
  }
};
